import { createContext, FC, PropsWithChildren, useState } from 'react'

import { Nullable } from 'cng-common/models/utils'
import { IReportPeriod } from 'partner360/models/report/iReportPeriod'
import { IQuarterlyMarketTableRow } from 'partner360/models/report/sobAnalyticsReports/iQuarterlyMarketTableRow'
import { IQuarterlyPartnerTableRow } from 'partner360/models/report/sobAnalyticsReports/iQuarterlyPartnerTableRow'

interface IExportPptxDataContext {
  rtm: string
  fYear: number
  netNdp: string
  view?: IReportPeriod
  reportTitle: string
  viewTitle: string
  category: string

  quarterMarketData: IQuarterlyMarketTableRow[]
  setQuarterMarketData: (data: IQuarterlyMarketTableRow[]) => void
  quarterMarketTotalData: Nullable<IQuarterlyMarketTableRow>
  setQuarterMarketTotalData: (data: IQuarterlyMarketTableRow) => void
  quarterPartnerData: IQuarterlyPartnerTableRow[]
  setQuarterPartnerData: (data: IQuarterlyPartnerTableRow[]) => void
  // the quarterly market table shows Expected Exit
  isExpectedExit: boolean
  setIsExpectedExit: (value: boolean) => void
}

export const ExportPptxDataContext = createContext<IExportPptxDataContext>({
  rtm: '',
  fYear: 0,
  netNdp: '',
  reportTitle: '',
  viewTitle: '',
  category: '',

  quarterMarketData: [],
  setQuarterMarketData: () => {},
  quarterMarketTotalData: null,
  setQuarterMarketTotalData: () => {},
  quarterPartnerData: [],
  setQuarterPartnerData: () => {},
  isExpectedExit: false,
  setIsExpectedExit: () => {},
})

interface IExportPptxDataProviderProps extends PropsWithChildren {
  rtm: string
  fYear: number
  netNdp: string
  category?: string
  reportTitle: string
  viewTitle: string
  view?: IReportPeriod
}

export const ExportPptxDataProvider: FC<IExportPptxDataProviderProps> = ({
  viewTitle,
  reportTitle,
  category = '',
  view,
  rtm,
  fYear,
  netNdp,
  children,
}) => {
  const [quarterPartnerData, setQuarterPartnerData] = useState<IQuarterlyPartnerTableRow[]>([])
  const [quarterMarketData, setQuarterMarketData] = useState<IQuarterlyMarketTableRow[]>([])
  const [quarterMarketTotalData, setQuarterMarketTotalData] =
    useState<Nullable<IQuarterlyMarketTableRow>>(null)
  const [isExpectedExit, setIsExpectedExit] = useState(false)

  return (
    <ExportPptxDataContext.Provider
      value={{
        viewTitle,
        reportTitle,
        category,
        rtm,
        fYear,
        netNdp,
        view,

        quarterMarketData,
        setQuarterMarketData,
        quarterMarketTotalData,
        setQuarterMarketTotalData,
        quarterPartnerData,
        setQuarterPartnerData,
        isExpectedExit,
        setIsExpectedExit,
      }}
    >
      {children}
    </ExportPptxDataContext.Provider>
  )
}
